import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { GasDividerModule } from '../../layout/gas-divider/gas-divider.module';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasButtonModule } from '../../forms/gas-button/gas-button.module';
import { GasFormKeyModule } from '../../utils/gas-form-key/gas-form-key.module';

import { GasFiltersDirective } from './gas-filters.directive';
import { GasFiltersComponent } from './gas-filters.component';

const COMPONENTS = [
  GasFiltersComponent,
];

const DIRECTIVES = [
  GasFiltersDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GasDividerModule,
    GasIconsModule,
    GasButtonModule,
    GasFormKeyModule,
  ],
})
export class GasFiltersModule { }
